/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import { HiOutlineDocument } from "react-icons/hi";
import { VscFileSubmodule } from "react-icons/vsc";
import { BsBook, BsPeople } from "react-icons/bs";
import { GrAttraction, GrRestaurant } from "react-icons/gr";
import {
  MdShop,
  MdMusicNote,
  MdOutlineMuseum,
  MdOutlineNightlight,
  MdOutlineHotelClass,
  MdOutlineFoodBank,
  MdOutlineFormatPaint,
  MdOutlineMapsHomeWork,
} from "react-icons/md";
import { SiHotelsdotcom } from "react-icons/si";
import { AiOutlineShopping, AiOutlineSearch } from "react-icons/ai";
import { BiCameraMovie } from "react-icons/bi";
import { GiTheater, GiBallerinaShoes } from "react-icons/gi";

import { Card } from "../../component/Component";
import { BreadCrumbComponent } from "../../../../middlewares/breadCrumb/BreadCrumbComponent";
import { useDashboardContext } from "../../../../context/dashboard/context/DashboardContext";
import { TableStatistics } from "./DashBoard";
import { Link } from "react-router-dom";
import { useAdminContext } from "../../../../context/admin/context/AdminContext";
import { addOneLevel } from "../../../../middlewares/breadCrumb/BreadCrumb";
import { pushLevel } from "../../../../middlewares";
import { getType } from "../contentStats/helper";
import { _TYPES_ } from "../../../doseeData/utils/types";

const ICONS_BY_KEY = {
  [_TYPES_.EVENT]: <VscFileSubmodule />,
  [_TYPES_.ATTRACTION]: <GrAttraction />,
  [_TYPES_.RESTAURANT]: <GrRestaurant />,
  [_TYPES_.HOTEL]: <SiHotelsdotcom />,
  [_TYPES_.MUSIC]: <MdMusicNote />,
  [_TYPES_.NEWS]: <BsBook />,
  [_TYPES_.SAFARI]: <MdOutlineMuseum />,
  [_TYPES_.TOURPACKAGE]: <GrAttraction />,
  [_TYPES_.CINEMA]: <BiCameraMovie />,
  [_TYPES_.MUSEUM]: <MdOutlineMuseum />,
  [_TYPES_.NIGHTLIFE]: <MdOutlineNightlight />,
  [_TYPES_.CLASSES]: <MdOutlineHotelClass />,
  [_TYPES_.SHOPPING]: <AiOutlineShopping />,
  [_TYPES_.FOOD]: <MdOutlineFoodBank />,
  [_TYPES_.BOOK]: <BsBook />,
  [_TYPES_.NEIGHBORHOOD]: <BsPeople />,
  [_TYPES_.ART]: <MdOutlineFormatPaint />,
  [_TYPES_.DANCE]: <GiBallerinaShoes />,
  [_TYPES_.THEATER]: <GiTheater />,
  [_TYPES_.CITYGUIDE]: <GrAttraction />,
  [_TYPES_.PARTY]: <BsBook />,
  [_TYPES_.THINGSTODO]: <HiOutlineDocument />,
  [_TYPES_.TIPSANDADVICE]: <BsBook />,
  [_TYPES_.MINISTRY]: <MdOutlineMapsHomeWork />,
  [_TYPES_.MOVIE]: <GiTheater />,
  [_TYPES_.GETTINGAROUND]: <MdOutlineMapsHomeWork />,
  [_TYPES_.PRODUCT]: <MdShop />,
  [_TYPES_.EMBASSY]: <HiOutlineDocument />,
  [_TYPES_.COMPANY]: <BsBook />,
  [_TYPES_.BESTOFAFRICA]: <MdOutlineHotelClass />,
};

const ICONS_BY_NAME = {
  regions: <MdOutlineMapsHomeWork />,
  countries: <MdOutlineMapsHomeWork />,
  "first level": <MdOutlineMapsHomeWork />,
  "second level": <MdOutlineMapsHomeWork />,
  "third level": <MdOutlineMapsHomeWork />,
  "fourth level": <MdOutlineMapsHomeWork />,
};

const getIconForCard = (card) =>
  (card?.key && ICONS_BY_KEY[card.key]) ||
  ICONS_BY_NAME[String(card?.name || "").toLowerCase()] ||
  <MdOutlineMapsHomeWork />;

const EXCLUDED_FOR_SINGLEADMIN = [
  "regions",
  "countries",
  "First Level",
  "Second Level",
  "Third Level",
  "Fourth Level",
];

const Content = () => {
  const { sysAdmin, setSingleAdmin } = useAdminContext();
  const { stats, fetchData } = useDashboardContext();

  const role = sysAdmin?.role;
  const isSuper = () => ["admin", "super_admin"].includes(role);

  useEffect(() => {
    if (!stats) fetchData();
  }, [stats]);

  const List = [
    isSuper() ? { name: "regions", quantity: stats ? stats.continent_region : "-", route: "/region/manage" } : null,
    isSuper() ? { name: "countries", quantity: stats ? stats.country : "-", route: "/countries" } : null,
    isSuper() ? { name: "First Level", quantity: stats ? stats.first_level : "-", route: "/levels/first" } : null,
    isSuper() ? { name: "Second Level", quantity: stats ? stats.second_level : "-", route: "/levels/second" } : null,
    isSuper() ? { name: "Third Level", quantity: stats ? stats.third_level : "-", route: "/levels/third" } : null,
    isSuper() ? { name: "Fourth Level", quantity: stats ? stats.fourth_level : "-", route: "/levels/fourth" } : null,

    { name: "events", quantity: stats ? stats?.event : "-", route: "/data/event", key: _TYPES_.EVENT },
    { name: "attractions", quantity: stats ? stats?.attraction : "-", route: "/data/attraction", key: _TYPES_.ATTRACTION },
    { name: "restaurants", quantity: stats ? stats?.restaurant : "-", route: "/data/restaurant", key: _TYPES_.RESTAURANT },
    { name: "best of africa", quantity: stats ? stats?.best_of_africa : "-", route: "/data/bestofafrica", key: _TYPES_.BESTOFAFRICA },
    { name: "music", quantity: stats ? stats?.music : "-", route: "/data/music", key: _TYPES_.MUSIC },
    { name: "news", quantity: stats ? stats?.news : "-", route: "/data/news", key: _TYPES_.NEWS },
    { name: "safaris", quantity: stats ? stats?.safari : "-", route: "/data/safari", key: _TYPES_.SAFARI },
    { name: "tour packages", quantity: stats ? stats?.tour_package : "-", route: "/data/tour/package", key: _TYPES_.TOURPACKAGE },
    { name: "cinema", quantity: stats ? stats?.cinema : "-", route: "/data/cinema", key: _TYPES_.CINEMA },
    { name: "museums", quantity: stats ? stats?.museum : "-", route: "/data/museum", key: _TYPES_.MUSEUM },
    { name: "night life", quantity: stats ? stats?.nightlife : "-", route: "/data/nightlife", key: _TYPES_.NIGHTLIFE },
    { name: "hotels", quantity: stats ? stats?.hotel : "-", route: "/data/hotel", key: _TYPES_.HOTEL },
    { name: "classes", quantity: stats ? stats?.class : "-", route: "/data/class", key: _TYPES_.CLASSES },
    { name: "shopping", quantity: stats ? stats?.shopping : "-", route: "/data/shopping", key: _TYPES_.SHOPPING },
    { name: "food", quantity: stats ? stats?.food : "-", route: "/data/food", key: _TYPES_.FOOD },
    { name: "books", quantity: stats ? stats?.book : "-", route: "/data/book", key: _TYPES_.BOOK },
    { name: "neighborhoods", quantity: stats ? stats?.neighborhood : "-", route: "/data/neighborhood", key: _TYPES_.NEIGHBORHOOD },
    { name: "arts", quantity: stats ? stats?.art : "-", route: "/data/art", key: _TYPES_.ART },
    { name: "dance", quantity: stats ? stats?.dance : "-", route: "/data/dance", key: _TYPES_.DANCE },
    { name: "theaters", quantity: stats ? stats?.theater : "-", route: "/data/theater", key: _TYPES_.THEATER },
    { name: "City Guides", quantity: stats ? stats?.city_guide : "-", route: "/data/city/guide", key: _TYPES_.CITYGUIDE },
    { name: "Parties", quantity: stats ? stats?.party : "-", route: "/data/party", key: _TYPES_.PARTY },
    { name: "Things To Do", quantity: stats ? stats?.things_to_do : "-", route: "/data/things/todo", key: _TYPES_.THINGSTODO },
    { name: "Tips And Advice", quantity: stats ? stats?.tips_and_advice : "-", route: "/data/tips/advice", key: _TYPES_.TIPSANDADVICE },
    { name: "Ministries", quantity: stats ? stats?.ministry : "-", route: "/data/ministry", key: _TYPES_.MINISTRY },
    { name: "Movies", quantity: stats ? stats?.movie : "-", route: "/data/movie", key: _TYPES_.MOVIE },
    { name: "Getting Around", quantity: stats ? stats?.getting_around : "-", route: "/data/get/around", key: _TYPES_.GETTINGAROUND },
    { name: "Products", quantity: stats ? stats?.product : "-", route: "/data/product", key: _TYPES_.PRODUCT },
    { name: "Embassies", quantity: stats ? stats?.embassy : "-", route: "/data/embassy", key: _TYPES_.EMBASSY },
    { name: "Companies", quantity: stats ? stats?.company : "-", route: "/data/company", key: _TYPES_.COMPANY },
  ];

  const [query, setQuery] = useState("");
  const q = query.trim().toLowerCase();
  const filterByQuery = (arr) =>
    arr.filter(
      (item) =>
        item &&
        (String(item.name).toLowerCase().includes(q) ||
          String(item.quantity).toLowerCase().includes(q))
    );

  const geography = filterByQuery(
    List.filter(
      (x) =>
        x &&
        ["regions", "countries", "First Level", "Second Level", "Third Level", "Fourth Level"].includes(
          x.name
        )
    )
  );

  const coreContent = filterByQuery(
    List.filter(
      (x) =>
        x &&
        [
          _TYPES_.EVENT,
          _TYPES_.ATTRACTION,
          _TYPES_.RESTAURANT,
          _TYPES_.HOTEL,
          _TYPES_.SAFARI,
          _TYPES_.TOURPACKAGE,
          _TYPES_.BESTOFAFRICA,
          _TYPES_.CITYGUIDE,
          _TYPES_.NEIGHBORHOOD,
          _TYPES_.GETTINGAROUND,
        ].includes(x.key)
    )
  );

  const experiences = filterByQuery(
    List.filter(
      (x) =>
        x &&
        [
          _TYPES_.NIGHTLIFE,
          _TYPES_.PARTY,
          _TYPES_.THINGSTODO,
          _TYPES_.CLASSES,
          _TYPES_.SHOPPING,
          _TYPES_.FOOD,
        ].includes(x.key)
    )
  );

  const cultureAndArts = filterByQuery(
    List.filter(
      (x) =>
        x &&
        [_TYPES_.MUSEUM, _TYPES_.ART, _TYPES_.DANCE, _TYPES_.THEATER, _TYPES_.BOOK].includes(x.key)
    )
  );

  const mediaAndNews = filterByQuery(
    List.filter(
      (x) =>
        x &&
        [_TYPES_.NEWS, _TYPES_.CINEMA, _TYPES_.MOVIE, _TYPES_.MUSIC].includes(x.key)
    )
  );

  const orgsAndServices = filterByQuery(
    List.filter(
      (x) =>
        x &&
        [_TYPES_.MINISTRY, _TYPES_.COMPANY, _TYPES_.EMBASSY, _TYPES_.PRODUCT].includes(x.key)
    )
  );

  const handleClick = (card) => {
    if (!EXCLUDED_FOR_SINGLEADMIN.includes(card?.name)) {
      setSingleAdmin({
        ids: [sysAdmin?.admin_id],
        type: getType({ field: card?.key }),
        route: "/",
      });
      addOneLevel({
        id: 0,
        name: "",
        route: "/levels/first",
        level: "",
        country_id: 0,
        data: {
          data: {
            name: "",
            country_id: 0,
            first_level_id: 0,
            second_level_id: 0,
            third_level_id: 0,
            fourth_level_id: 0,
            level: "",
          },
        },
      });
      pushLevel({
        level: {
          id: 0,
          name: "",
          level: "All",
          route: "/levels/first",
          data: null,
        },
      });
    }
  };

  // Wrapper for sections with safe overflow clipping to prevent horizontal scroll
  const SectionShell = ({ title, hint, tone = "from-emerald-400/10 via-teal-400/10 to-cyan-400/10", count = 0, children }) => (
    <section aria-label={title} className="relative overflow-hidden">
      {/* Ambient glow (clipped by overflow-hidden to avoid page x-scroll) */}
      <div className={`pointer-events-none absolute -inset-1 rounded-3xl bg-gradient-to-r ${tone} blur-2xl`} aria-hidden />
      <div className="relative rounded-3xl border border-gray-200 bg-white/85 shadow-sm backdrop-blur">
        <div className="flex items-center justify-between gap-3 px-5 pt-4">
          <div className="min-w-0">
            <h3 className="text-sm font-semibold tracking-tight text-gray-900 truncate" title={title}>{title}</h3>
            {hint ? <p className="mt-0.5 text-xs text-gray-600 truncate" title={hint}>{hint}</p> : null}
          </div>
          <span className="shrink-0 rounded-full bg-gray-100 px-3 py-1 text-[11px] font-semibold text-gray-700">
            {Number(count).toLocaleString()} items
          </span>
        </div>
        <div className="px-5 pb-5 pt-3">
          {/* Ensure children grids can't force overflow */}
          <div className="min-w-0">{children}</div>
        </div>
      </div>
    </section>
  );

  const totalVisible = useMemo(
    () =>
      geography.length +
      coreContent.length +
      experiences.length +
      cultureAndArts.length +
      mediaAndNews.length +
      orgsAndServices.length,
    [
      geography.length,
      coreContent.length,
      experiences.length,
      cultureAndArts.length,
      mediaAndNews.length,
      orgsAndServices.length,
    ]
  );

  return (
    // Clip any decorative layers that might extend beyond viewport and cause x-scroll
    <div className="relative h-full w-full overflow-y-auto overflow-x-hidden supports-[overflow:clip]:overflow-x-clip">
      {/* Background decor (kept subtle) */}
      <div className="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
        <div className="absolute -top-24 left-1/2 h-72 w-72 -translate-x-1/2 rounded-full bg-emerald-300/15 blur-3xl" />
        <div className="absolute top-20 -left-10 h-64 w-64 rounded-full bg-indigo-300/15 blur-3xl" />
        <div className="absolute bottom-10 -right-10 h-64 w-64 rounded-full bg-amber-300/15 blur-3xl" />
      </div>

      <div className="mx-auto w-full max-w-7xl p-4">
        <BreadCrumbComponent default_value={true} />

        {/* Sticky toolbar */}
        <div className="sticky top-0 z-10 mb-4 -mt-1 rounded-2xl border border-gray-200 bg-white/85 p-3 shadow-sm backdrop-blur">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div className="min-w-0">
              <h2 className="text-base font-semibold tracking-tight text-gray-900">Content Library</h2>
              <p className="text-xs text-gray-600">
                Navigate modules by theme. {stats ? "Live counts loaded." : "Loading…"}
              </p>
            </div>
            <div className="relative w-full sm:w-80">
              <AiOutlineSearch
                className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400"
                aria-hidden="true"
              />
              <input
                type="text"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Search categories…"
                className="w-full rounded-lg border border-gray-300 bg-white/90 py-2 pl-9 pr-3 text-sm text-gray-900 placeholder:text-gray-400 shadow-sm focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-200"
              />
              {q && (
                <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[11px] text-gray-500">
                  {totalVisible} match{totalVisible === 1 ? "" : "es"}
                </span>
              )}
            </div>
          </div>
        </div>

        <div className="space-y-8">
          <SectionShell
            title="Geography & Levels"
            hint="Manage regions, countries, and hierarchical levels."
            tone="from-sky-400/10 via-blue-400/10 to-indigo-400/10"
            count={geography.length}
          >
            <div className="grid min-w-0 grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 2xl:grid-cols-8">
              {geography.map((card, idx) => (
                <Link
                  to={card?.route}
                  key={`geo-${idx}-${card?.name}`}
                  onClick={() => handleClick(card)}
                  className="min-w-0 focus:outline-none"
                >
                  <Card
                    card={{
                      name: card.name,
                      quantity: card.quantity,
                      icon: getIconForCard(card),
                    }}
                  />
                </Link>
              ))}
            </div>
          </SectionShell>

          <SectionShell
            title="Core Content"
            hint="Primary editorial and destination content."
            tone="from-emerald-400/10 via-teal-400/10 to-cyan-400/10"
            count={coreContent.length}
          >
            <div className="grid min-w-0 grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 2xl:grid-cols-8">
              {coreContent.map((card, idx) => (
                <Link
                  to={card?.route}
                  key={`core-${idx}-${card?.name}`}
                  onClick={() => handleClick(card)}
                  className="min-w-0 focus:outline-none"
                >
                  <Card
                    card={{
                      name: card.name,
                      quantity: card.quantity,
                      icon: getIconForCard(card),
                    }}
                  />
                </Link>
              ))}
            </div>
          </SectionShell>

          <SectionShell
            title="Experiences"
            hint="Activities, classes, food and shopping."
            tone="from-amber-400/10 via-orange-400/10 to-yellow-400/10"
            count={experiences.length}
          >
            <div className="grid min-w-0 grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 2xl:grid-cols-8">
              {experiences.map((card, idx) => (
                <Link
                  to={card?.route}
                  key={`exp-${idx}-${card?.name}`}
                  onClick={() => handleClick(card)}
                  className="min-w-0 focus:outline-none"
                >
                  <Card
                    card={{
                      name: card.name,
                      quantity: card.quantity,
                      icon: getIconForCard(card),
                    }}
                  />
                </Link>
              ))}
            </div>
          </SectionShell>

          <SectionShell
            title="Culture & Arts"
            hint="Museums, arts, dance, theaters, and books."
            tone="from-indigo-400/10 via-violet-400/10 to-purple-400/10"
            count={cultureAndArts.length}
          >
            <div className="grid min-w-0 grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 2xl:grid-cols-8">
              {cultureAndArts.map((card, idx) => (
                <Link
                  to={card?.route}
                  key={`culture-${idx}-${card?.name}`}
                  onClick={() => handleClick(card)}
                  className="min-w-0 focus:outline-none"
                >
                  <Card
                    card={{
                      name: card.name,
                      quantity: card.quantity,
                      icon: getIconForCard(card),
                    }}
                  />
                </Link>
              ))}
            </div>
          </SectionShell>

          <SectionShell
            title="Media & News"
            hint="Newsroom, cinema, movies, and music."
            tone="from-rose-400/10 via-pink-400/10 to-fuchsia-400/10"
            count={mediaAndNews.length}
          >
            <div className="grid min-w-0 grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 2xl:grid-cols-8">
              {mediaAndNews.map((card, idx) => (
                <Link
                  to={card?.route}
                  key={`media-${idx}-${card?.name}`}
                  onClick={() => handleClick(card)}
                  className="min-w-0 focus:outline-none"
                >
                  <Card
                    card={{
                      name: card.name,
                      quantity: card.quantity,
                      icon: getIconForCard(card),
                    }}
                  />
                </Link>
              ))}
            </div>
          </SectionShell>

          <SectionShell
            title="Organizations & Services"
            hint="Ministries, companies, embassies, and products."
            tone="from-lime-400/10 via-green-400/10 to-emerald-400/10"
            count={orgsAndServices.length}
          >
            <div className="grid min-w-0 grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 2xl:grid-cols-8">
              {orgsAndServices.map((card, idx) => (
                <Link
                  to={card?.route}
                  key={`org-${idx}-${card?.name}`}
                  onClick={() => handleClick(card)}
                  className="min-w-0 focus:outline-none"
                >
                  <Card
                    card={{
                      name: card.name,
                      quantity: card.quantity,
                      icon: getIconForCard(card),
                    }}
                  />
                </Link>
              ))}
            </div>
          </SectionShell>

          <section aria-label="Insights" className="overflow-hidden">
            <div className="rounded-3xl border border-gray-200 bg-white/85 p-4 shadow-sm backdrop-blur">
              <TableStatistics />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Content;
